<template>
  <div class="collaspe">
      <slot></slot>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
    name: 'g-collapse',
    props: {
        value: {
            type: Array,
            default: ()=> {
                return []
            }
        },
        single: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        let activeArr = []
        this.$children.forEach(item => {
            item.isSingle = this.single
            if(item.$options.name === 'g-collapse-item' && this.value.indexOf(item.name) >= 0) {
                activeArr.push(item.name)
            }
        })
        this.EventBus.$on('collapseChange', (acceptArr) => {
            this.$emit('input', acceptArr)
        })
        this.EventBus.$emit('collapseChange',activeArr)
        
    },
    data() {
        return {
            EventBus: new Vue()
        }
    },
    provide() {
        return {
            EventBus: this.EventBus
        }
    }
}
</script>

<style lang="scss" scoped>
.collaspe{
    border:1px solid #ddd;
    border-radius:4px;
    border-top-left-radius:4px;
    border-top-right-radius:4px;
}
</style>